import axios from "axios";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`,
});

async function fetchTestReports(token, topic) {
  try {
    const response = await API.post("/reportsasmarks", { token, topic });
    // const response = {
    //   status: 200,
    //   data: [
    //     {
    //       id: 1,
    //       title: "Animals",
    //       outcomes: [
    //         "Identify that animals are living things.",
    //         "Recognize that animals move, eat, and grow.",
    //         "Differentiate between big and small animals.",
    //         "Explain that animals exist all around us in different environments.",
    //       ],
    //       reports: [
    //         {
    //           id: 1,
    //           name: "Pick the Right One",
    //           ttt_mark: 10,
    //           got_mark: 5,
    //         },
    //         {
    //           id: 2,
    //           name: "Can You Find the Match",
    //           ttt_mark: 20,
    //           got_mark: 5,
    //         },
    //         {
    //           id: 3,
    //           name: "Drag it to the Right Spot",
    //           ttt_mark: 30,
    //           got_mark: 15,
    //         },
    //       ],
    //     },
    //     {
    //       id: 2,
    //       title: "Animals sounds1",
    //       outcomes: [
    //         "Identify that animals are living things.1",
    //         "Recognize that animals move, eat, and grow.1",
    //         "Differentiate between big and small animals.1",
    //         "Explain that animals exist all around us in different environments.1",
    //       ],
    //       reports: [
    //         {
    //           id: 1,
    //           name: "Pick the Right One",
    //           ttt_mark: 101,
    //           got_mark: 51,
    //         },
    //         {
    //           id: 2,
    //           name: "Can You Find the Match",
    //           ttt_mark: 201,
    //           got_mark: 51,
    //         },
    //         {
    //           id: 3,
    //           name: "Drag it to the Right Spot",
    //           ttt_mark: 301,
    //           got_mark: 151,
    //         },
    //       ],
    //     },
    //     {
    //       id: 3,
    //       title: "Birds2",
    //       outcomes: [
    //         "Identify that animals are living things.2",
    //         "Recognize that animals move, eat, and grow.2",
    //         "Differentiate between big and small animals.2",
    //         "Explain that animals exist all around us in different environments.2",
    //       ],
    //       reports: [
    //         {
    //           id: 1,
    //           name: "Pick the Right One",
    //           ttt_mark: 1011,
    //           got_mark: 511,
    //         },
    //         {
    //           id: 2,
    //           name: "Can You Find the Match",
    //           ttt_mark: 2011,
    //           got_mark: 511,
    //         },
    //         {
    //           id: 3,
    //           name: "Drag it to the Right Spot",
    //           ttt_mark: 3011,
    //           got_mark: 1511,
    //         },
    //       ],
    //     },
    //   ],
    // };
    return response;
  } catch (error) {
    console.error("Error fetching subjects:", error);
    throw error;
  }
}

export { fetchTestReports };
